import PropTypes from 'prop-types';
import React from 'react';
import Image from './Image';

class Section extends React.Component {
	render() {
		const { image, title, text } = this.props;

		return (
			<div className="ms-form__intro">
				{image && <Image image={image} />}
				{title && <h3>{title}</h3>}
				{text && <span className="text-subline-sm" dangerouslySetInnerHTML={{ __html: text }} />}
			</div>
		);
	}
}

export default Section;

Section.propTypes = {
	image: PropTypes.object,
	title: PropTypes.string,
	text: PropTypes.string,
};
